import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a3ee2e18"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "tag-set-wrapper" };
const _hoisted_2 = ["onClick"];
import { hasTag, toggleTag } from "src/shared/Tags";
import { isInternal } from "src/shared/Tags";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TagSetMultiSelect',
    props: {
        tags: {},
        options: {}
    },
    emits: ["update:tags"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const toggle = (tag) => {
            const clone = [...props.tags];
            toggleTag(clone, tag);
            emit("update:tags", clone);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["tag-set-wrapper__tag", {
                                'tag-set-wrapper__tag--internal': _unref(isInternal)(option.value),
                                active: _unref(hasTag)(_ctx.tags, option.value),
                            }]),
                        key: option.value,
                        onClick: ($event) => (toggle(option.value))
                    }, [
                        _createElementVNode("span", null, _toDisplayString(option.displayName), 1 /* TEXT */)
                    ], 10 /* CLASS, PROPS */, _hoisted_2));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
